import { ChangeEvent } from 'react';

interface Props {
    id: string;
    checked: boolean;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    label: string;
}

export default function Radio(props: Props) {
    return (
        <div className="relative flex items-center gap-x-2">
            <div
                className={`border-regular flex h-5 w-5 items-center justify-center rounded-full transition-colors duration-100 ${props.checked ? 'bg-accent' : ''}`}
            >
                <div
                    className={`m-auto h-2 w-2 rounded-full transition-colors duration-100 ${props.checked ? 'bg-black' : ''}`}
                />
            </div>
            <input
                onChange={props.onChange}
                className="absolute left-0 h-5 w-5 opacity-0"
                checked={props.checked}
                type="radio"
                id={props.id}
            />
            <label className="text-sm sm:text-base" htmlFor={props.id}>
                {props.label}
            </label>
        </div>
    );
}
